module.exports = __webpack_public_path__ + "img/excle_ico.09faf566.svg";